module.exports = __webpack_public_path__ + "static/img/ycyf_logo.c247fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/appImg/ycyf_logo.png
// module id = xBqH
// module chunks = 41